import './TranscriptsBySubjectAreaInstructionsPage.css';

const TranscriptsBySubjectAreaInstructionsPage = () => (
  <div className="subject-area-instructions-page page">
    <div className="subject-area-instructions-header">
      <h2 className="subject-area-instructions-title">Instructions: Reviewing subject area transcripts</h2>
    </div>
    <ul className="subject-area-instructions-list">
      <li>
        With a partner, or on your own, analyze the transcript information for the subject area(s) you were assigned.
        Keep the following questions in mind:
        <ul className="subject-area-instructions-sublist">
          <li>Did students persist in the discipline over time?</li>
          <li>Are students accessing advanced coursework in that discipline?</li>
          <li>Are they likely to be postsecondary ready in that discipline?</li>
          <li>
            What kind of career and technical education (CTE) courses are students taking, if any? If students are
            taking CTE courses, do they seem to be completing CTE pathways?
          </li>
        </ul>
      </li>
      <li>
        Jot down your observations and takeaways from this information on stickies for your assigned subject area(s) and
        place them in Box 2 of Artifact #3.
      </li>
      <li>Present your takeaways to others on your school team.</li>
      <li>
        When you are done with both transcript review activities (&ldquo;by student&rdquo;, and &ldquo;by
        subject&rdquo;), come back together as a whole group to summarize the observations from Box 1 and Box 2 into
        3&ndash;5 key takeaways in Box 3.
      </li>
    </ul>
    <p className="subject-area-instructions-note">
      <em>
        Note: While transcripts reflect courses taken in high school, certain courses (e.g., Algebra I, Physical Science
        Honors) taken in middle school count toward college eligibility. These don&rsquo;t appear on the transcripts,
        but the EOAA accounts for these courses.
      </em>
    </p>
  </div>
);

export default TranscriptsBySubjectAreaInstructionsPage;
